import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import { IBaseResponse } from "core/interfaces/data/Base";
import { HSB_AUTH_COOKIE } from "./Constants";
import CookieManager from "utils/CookieManager";

export interface IPaymentIntent extends IBaseResponse {
	ClientSecret: string;
}

// questo serve per fare la richiesta una seconda volta se in caso la prima non va a buon fine
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;
class PagamentiRepository {
	public getClientSecret = async (totale: number, idPreventivo: string, nominativoUtente: string, culture: string) => {
		const send = { NominativoUtente: nominativoUtente, Total: totale, IdPreventivo: idPreventivo, Culture: culture };
		try {
			const url = window.CONFIG.REACT_APP_WS_HSB + "/StripeStartPayment";

			const res = await axios.post<typeof send, AxiosResponse<IPaymentIntent>>(url, send, {
				headers: {
					"Content-Type": "application/json; charset=utf-8",
					Accept: "application/json",
				},
			});
			if (res.data?.Errors && res.data.Errors.length > 0) console.error(res.data.Errors);
			return res.data;
		} catch (err) {
			console.error(err);
			return;
		}
	};

	public getFattura = async (idEcDoc: number, culture: string) => {
		// const send = { IdPreventivo: idPreventivo, Culture: culture };
		try {
			const url = `${window.CONFIG.REACT_APP_ATL_BASE_URL}/api/fatture/GetFattura?idEcDOC=${idEcDoc}&culture=${culture}`;

			var cookieHSB = await CookieManager.get(HSB_AUTH_COOKIE);

			await axios
				.get(url, {
					responseType: "arraybuffer",
					headers: { accept: "application/pdf", Authorization: cookieHSB },
				})
				.then((response) => {
					var fileToDownload = response.data;

					var contentDisposition: string[] = response.headers["content-disposition"].split(";");
					
					var filename = contentDisposition
						.filter((x) => {
							return x.includes("filename=");
						})?.[0]
						.split("=")[1]
						.replaceAll('"', "")
						.trim();
					var a = document.createElement("a");
					document.body.appendChild(a);
					a.setAttribute("display", "none");

					var blob = new Blob([fileToDownload], { type: "application/pdf" });
					var url = window.URL.createObjectURL(blob);
					a.href = url;
					a.download = filename.trim();
					a.click();
					window.URL.revokeObjectURL(url);
				});
		} catch (err) {
			console.error(err);
			return;
		}
	};
}
var PagamentiRep = new PagamentiRepository();
export default PagamentiRep;
